/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable consistent-return */
const unitePayments = payments => {
    const uniqueSourceIds = new Set(payments.map(el => el.source_id))

    const getSecondPaymentsFromPayment = payment => {
        return payments
            .filter(el => el.payment_type_id === payment.payment_type_id)
            .map(el => el.paymentTypeBySecondPaymentTypeId)
            .filter(Boolean)
            .filter(
                (value, index, self) =>
                    index === self.findIndex(t => t.id === value.id)
            )
    }

    const unitePaymentsForOneSource = paymentsForOneSource => {
        const uniquePaymentTypes = new Set(
            paymentsForOneSource.map(el => el.payment_type_id)
        )

        const uniquePayments = Array.from(uniquePaymentTypes).map(
            payment_type_id => {
                return paymentsForOneSource.find(
                    el => el.payment_type_id === payment_type_id
                )
            }
        )

        return uniquePayments.map(el => {
            return {
                ...el,
                paymentTypeBySecondPaymentTypeId:
                    getSecondPaymentsFromPayment(el),
            }
        })
    }

    const result = {}
    uniqueSourceIds.forEach(source_id => {
        const paymentsForOneSource = payments.filter(
            el => el.source_id === source_id
        )
        result[source_id] = unitePaymentsForOneSource(paymentsForOneSource)
    })
    return result
}

export default unitePayments
